export default __webpack_public_path__ + "static/media/docs.9aceba0d.png";